// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Cask, Action } = initSchema(schema);

export {
  Cask,
  Action
};